{
  "slug": "what-is-iq",
  "title": "什么是智商?",
  "description": "了解智商的含义,智商测试测量什么,以及智商分数的重要限制。",
  "summary": "智商, 智商的缩写, 是一个标准化的分数,旨在描述在选定的认知任务的表现相比,同龄人.",
  "sections": [
    {
      "heading": "智商分数代表什么",
      "paragraphs": [
        "现代智商测试将精心设计的任务的结果结合起来,并将其与具有代表性的参考组进行比较。 100,因此结果描述的是相对性能,而不是智能的绝对值。",
        "分数最好理解为一个估计值,测试条件、健康、语言、动机、熟悉测试格式和正常测量误差都会影响结果。"
      ]
    },
    {
      "heading": "智商测试通常评估什么",
      "paragraphs": ["专业电池采样几种认知能力,而不是依赖于一种类型的谜题。"],
      "bullets": ["口头理解和获得的知识", "視覺空間和流體推理", "工作记忆和注意力", "处理速度"]
    },
    {
      "heading": "智商不衡量什么",
      "paragraphs": [
        "智商不能完全反映创造力、实际判断力、好奇心、情感技能、动机、智慧或专业知识，也不能决定一个人的价值或未来。",
        "由合格的专业人士进行的监督评估更适合于临床、教育或法律决策,而在线智商测试的结果应该是指示性的。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "IQ代表什么?",
      "answer": "智商代表智商,一个标准化的分数,比较选定的认知表现与基于年龄的参考组。"
    },
    {
      "question": "在线智商测试是否是一种诊断?",
      "answer": "在线结果仅供参考,不应取代合格专业人士的评估。"
    }
  ],
  "related": ["how-is-iq-measured", "iq-vs-intelligence", "what-is-the-average-iq"]
}
